<template>
  <div class="grid-container">
    <div v-if="errorMessage" class="b2b-callout b2b-callout--alert mb-3" qaid="user-exists-alert">
      <i class="b2b-callout__icon md-18">warning</i>
      {{ errorMessage }}
    </div>

    <div class="section-header section-header--dividing section-header--xl mt-3">
      <h1 class="heading">
        {{ pageHeading }}
      </h1>
    </div>

    <div class="grid-x grid-margin-x mb-6">
      <div class="cell medium-6 large-4 max-w-sm">
        <form method="post" qaid="add-user-details-form">
          <fieldset>
            <div class="form-group">
              <label for="first-name" class="form-label" v-html="legendFirstName"> </label>
              <input
                id="first-name"
                v-model="firstName"
                type="text"
                name="first-name"
                qaid="first-name"
                required="required"
                class="form-control"
              />
            </div>
            <div class="form-group is-required">
              <label for="last-name" class="form-label" v-html="legendLastName"> </label>
              <input
                id="last-name"
                v-model="lastName"
                type="text"
                name="last-name"
                required="required"
                qaid="last-name"
                class="form-control"
              />
            </div>
            <div class="form-group is-required ">
              <label for="email-address" class="form-label" v-html="legendEmailAddress"> </label>
              <input
                id="email-address"
                v-model="emailAddress"
                type="email"
                name="email-address"
                required="required"
                qaid="email-address"
                class="form-control"
              />
            </div>
          </fieldset>

          <fieldset class="form-fieldset">
            <input id="CSRFToken" type="hidden" :value="token" name="CSRFToken" />
            <legend class="form-fieldset__legend" v-html="legendUserRole"></legend>
            <label
              v-for="(item, index) in itemsParsed.roles"
              :key="index"
              :qaid="`option-${index}`"
              :for="`option-${index}`"
              class="radio"
            >
              <input
                :id="`option-${index}`"
                v-model="role"
                type="radio"
                name="user-role"
                :value="item.id"
                :qaid="`option-${index}`"
                required="required"
              />
              <span class="control-indicator"></span>
              {{ item.name }}
            </label>
          </fieldset>

          <div class="buttons">
            <trek-button id="saveAddUserButton" primary qaid="save-add-button" type="submit" :value="labelSaveButton">
              <span v-html="labelSaveButton"></span>
            </trek-button>
            <trek-link id="cancelAddUserButton" button secondary :href="cancelButtonRef" qaid="cancel-add-button">
              <span v-html="labelCancelButton"></span>
            </trek-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import TrekButton from '@/components/TrekButton';
import TrekLink from '@/components/TrekLink';

export default {
  components: {TrekButton, TrekLink},
  props: {
    items: {
      type: String,
      default: '{}',
    },
    legendFirstName: {
      type: String,
      default: '',
    },
    legendLastName: {
      type: String,
      default: '',
    },
    legendEmailAddress: {
      type: String,
      default: '',
    },
    legendUserStatus: {
      type: String,
      default: '',
    },
    legendUserRole: {
      type: String,
      default: '',
    },
    labelSaveButton: {
      type: String,
      default: '',
    },
    labelCancelButton: {
      type: String,
      default: '',
    },
    token: {
      type: String,
      default: '',
    },
    cancelButtonRef: {
      type: String,
      default: '',
    },
    pageHeading: {
      type: String,
      default: '',
    },
    userAlreadyExistsMessage: {
      type: String,
      default: '',
    },
    systemDownCannotSubmitMessage: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      role: '',
      lastName: '',
      firstName: '',
      emailAddress: '',
      userAlreadyExists: '',
      systemDown: '',
      userAlreadyExistsMessageEmail: '',
      errorMessage: '',
    };
  },

  computed: {
    itemsParsed() {
      return JSON.parse(this.items);
    },
  },

  created() {
    if (this.itemsParsed) {
      this.role = this.itemsParsed.selectedRole;
      this.lastName = this.itemsParsed.lastName;
      this.firstName = this.itemsParsed.firstName;
      this.emailAddress = this.itemsParsed.emailAddress;
      this.userAlreadyExists = this.itemsParsed.userAlreadyExists;
      this.systemDown = this.itemsParsed.systemDown;
      if (this.systemDown) {
        this.errorMessage = this.systemDownCannotSubmitMessage;
      } else if (this.userAlreadyExists && this.userAlreadyExistsMessage && this.userAlreadyExistsMessage.length) {
        this.errorMessage = this.userAlreadyExistsMessage.replace('{0}', this.emailAddress);
      }
    }
  },
};
</script>
